import script from "./GetSamples.vue?vue&type=script&setup=true&lang=js"
export * from "./GetSamples.vue?vue&type=script&setup=true&lang=js"

import "./GetSamples.vue?vue&type=style&index=0&id=413e81df&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-413e81df"]])

export default __exports__